import { useMutation, useQuery } from '@tanstack/react-query';
import { getFeatureFlags, updateFeatureFlag } from '@api/feature-flags';
import { formatApiError } from '@api/common/errors';
import { getMutationAlertMessages, getQueryAlertMessages } from '@common/queries/formatters/alerts';
import queryClient from './query-client';
const keys = {
    allFeatures: () => ['all']
};
export function useFeatureFlagMap(enabled = true) {
    return useQuery({
        queryKey: keys.allFeatures(),
        queryFn: () => getFeatureFlags(),
        select: (data) => data.items.reduce((featureFlagMap, flag) => {
            featureFlagMap[flag.id] = flag.enabled;
            return featureFlagMap;
        }, {}),
        meta: getQueryAlertMessages(error => formatApiError(error, 'Failed to load feature-flags')),
        enabled,
        staleTime: Infinity
    });
}
export function useFeatureFlag() {
    return useQuery({
        queryKey: keys.allFeatures(),
        queryFn: getFeatureFlags,
        meta: getQueryAlertMessages(error => formatApiError(error, 'Failed to load feature-flags'))
    });
}
export function useUpdateFeatureFlagMutation() {
    return useMutation({
        mutationFn: ({ id, enabled }) => updateFeatureFlag(id, enabled),
        onSuccess: async () => {
            await queryClient.invalidateQueries(keys.allFeatures());
        },
        meta: getMutationAlertMessages(error => formatApiError(error, 'Failed to update Feature Flag'), 'Feature Flag updated!')
    });
}
